<template>
  <v-tabs color="transparent" slider-color="primary">
    <v-tab :ripple="false" v-for="lang in langs" :key="lang">
      <v-icon
        v-if="errors[`title.${lang}`] || errors[`description.${lang}`]"
        size="0.8rem"
        class="mr-1"
        color="red"
      >fas fa-exclamation</v-icon>
      <span class="lang-label">{{ lang }}</span>
      <span v-if="isAiLang(lang)" class="ai-badge">
        <span class="ai-badge__label">AI</span>
      </span>
    </v-tab>

    <v-tab-item touch v-for="lang in langs" :key="lang">
      <TabItemContent class="mt-1" :form="form" :errors="errors" :lang="lang" />
    </v-tab-item>
  </v-tabs>
</template>

<script>
import TabItemContent from "./TabItemContent";
export default {
  props: ["form", "errors"],
  components: { TabItemContent },
  data() {
    return {
      langs: ["fi", "se", "en"],
    };
  },
  methods: {
    isAiLang(lang) {
      return ["se", "en"].includes(lang);
    },
  },
};
</script>

<style lang="scss" scoped>
.lang-label {
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.ai-badge {
  display: inline-flex;
  align-items: center;
  margin-left: 6px;
  padding: 4px 8px;
  border-radius: 999px;
  background: #111;
  color: #fff;
  font-weight: 700;
  font-size: 0.7rem;
  line-height: 1;
  letter-spacing: 0.02em;
  box-shadow: inset 0 0 0 1px #000;
}

.ai-badge__label {
  line-height: 1;
}
</style>
